import { ButtonPrimary } from 'components/molecules/Button';
import { useTranslation } from 'react-i18next';
import { IoIosUnlock } from 'react-icons/io';
import { Link } from 'react-router-dom';

const UnlockButton = ({ btnCard = false }) => {
  const { t } = useTranslation();
  return (
    <Link
      to={`#`}
      className="button-reactour"
      style={{
        ...(btnCard ? { width: '100%' } : {}),
        textDecoration: 'none',
      }}
    >
      <ButtonPrimary
        style={
          btnCard
            ? {
                borderRadius: '10px',
                width: '100%',
                padding: '5px',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '4px',
              }
            : {}
        }
      >
        <IoIosUnlock />
        {t('button.button_msg20')}
      </ButtonPrimary>
    </Link>
  );
};

export default UnlockButton;
